export default {
    methods: {
        goToTicket (ticketId) {
            window.open("/tickets/" + ticketId, "_blank");
        },

        getTicketReferenceColorStyles (status, priority) {
            if (_.lowerCase(status) === "closed") {
                return "bg-gray-200 text-gray-600 hover:bg-gray-300";
            }

            switch (_.lowerCase(priority)) {
                case "low":
                    return "text-green-600 bg-green-100 hover:bg-green-200";
                case "medium":
                    return "text-indigo-600 bg-indigo-100 hover:bg-indigo-200";
                case "high":
                    return "text-red-600 bg-red-100 hover:bg-red-200";
                default:
                    return "text-gray-600 bg-gray-200 hover:bg-gray-100";
            }

        },
    }
};
